import React, { useState } from "react";

export default function Les2() {
	const acc = { user: "", pass: "" };
	const [Account, setAccount] = useState(acc);
	return (
		<div>
			<p>Log.. {JSON.stringify(Account)}</p>
			<form>
				<input
					type="text"
					value={Account.user}
					placeholder="User"
					onChange={(e) => {
						e.preventDefault();
						setAccount({ ...Account, user: e.target.value });
					}}
				/>{" "}
				<br />
				<input
					type="text"
					placeholder="Password"
					value={Account.pass}
					onChange={(e) => {
						e.preventDefault();
						setAccount({ ...Account, pass: e.target.value });
					}}
				/>
        <br />
				<button
					onClick={(e) => {
						e.preventDefault();
					}}
				>
					setAccount
				</button>
				<button
					onClick={(e) => {
						e.preventDefault();
						setAccount(acc);
					}}
				>
					Clear
				</button>
			</form>
		</div>
	);
}



// WEBPACK FOOTER //
// src/page/les2.js